export function getLeadFormCreativeId({ isNewVin, pageNameLegacy, formName, isZipForm }) {
  const prefix = isNewVin ? 'new' : 'used';
  const zipPrefix = isZipForm ? 'ZIP_' : '';
  return `${prefix}-${zipPrefix}${formName}-${pageNameLegacy}`;
}
